import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppState} from "lib/redux/store";
import {DEFAULT_LANGUAGE, isValidLanguage, Language} from "./translations";


interface I18nState {
    language: Language
}

const initialState: I18nState = {
    language: detectLanguage()
}

const {actions, reducer} = createSlice({
    name: 'i18n',
    initialState: initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<Language>) => {
            state.language = action.payload
        }
    }
});


function getI18nState(state: AppState): I18nState {
    return state.i18n;
}

const selectors = {
    language: (state: AppState) => getI18nState(state).language
}

export {reducer as i18nReducer};
export {actions as i18nActions};
export {selectors as i18nSelectors};

function detectLanguage(): Language {
    const preferredBrowserLang = navigator.languages
        .map(l => l.slice(0, 2)?.toLowerCase())
        .find(isValidLanguage);
    return preferredBrowserLang ?? DEFAULT_LANGUAGE;
}